module.exports = __webpack_public_path__ + "static/media/protege_tus_datos_1.feb00a2b.png";